import { useCallback, useEffect, useRef, useState } from 'react';
import type { Message } from '../types/chat';

export function useMessageLog(initialMessages: Message[] = []) {
    const [messages, setMessages] = useState<Message[]>(initialMessages);
    const endRef = useRef<HTMLDivElement>(null);
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            endRef.current?.scrollIntoView({ behavior: 'instant', block: 'nearest' });
        } else {
            endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }, [messages]);

    const append = useCallback((...msgs: Message[]) => {
        setMessages((prev) => [...prev, ...msgs]);
    }, []);

    return { messages, append, setMessages, endRef };
}
